export const ActivateAccessControlIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.88092"
        y="0.514282"
        width="13.7354"
        height="13.7354"
        rx="3.27779"
        fill="white"
        fill-opacity="0.9"
      />
      <rect
        x="3.88092"
        y="3.13065"
        width="8.11908"
        height="8.11908"
        rx="1.93751"
        fill="url(#paint0_linear_1444_19782)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1444_19782"
          x1="7.94046"
          y1="3.13065"
          x2="7.94046"
          y2="11.2497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64837E" />
          <stop offset="1" stopColor="#64837E" stop-opacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
